// extracted by mini-css-extract-plugin
export default {"bar":"Tabs_bar__K2kC8"};